import {vnTemplate} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/vnTemplate";
import {pagination_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/pagination_template";
import {filterSimple_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/filterSimple_template";
import {resultsInfo_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/resultsInfo_template";
import {multipleSelector_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/multipleSelector_template";
import {filterDate_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/filterDate_template";
import {filterPreset_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/filterPreset_template";
import {amCharts_v4_column_chart} from "./amCharts_v4_column_chart";
import {amCharts_v4_pie_chart} from "./amCharts_v4_pie_chart";
import {amCharts_v4_area_line_chart} from "./amCharts_v4_area_line_chart";
import {downloadCSV} from "../../../vendor/valnet/valnet_jslib/vnHelpers/helper_functions";
import {filterAutocomplete_template} from "./filterAutocomplete_template";
import {infoButton_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/infoButton_template";

declare var ko: any;

export class author_management_template extends vnTemplate{

    protected filter: filterSimple_template;
    protected resultInfos: resultsInfo_template;
    protected pagination: pagination_template;
    protected dateFilter: filterDate_template;
    protected networkCategoriesFilter : multipleSelector_template;
    protected filterContentType : multipleSelector_template;
    protected intentFilter : multipleSelector_template;
    public filterUser: filterAutocomplete_template;
    protected filterPreset: filterPreset_template;
    public publishCount: amCharts_v4_column_chart;
    public publishCountStacked: amCharts_v4_column_chart;
    public activeSessions: amCharts_v4_pie_chart;
    public totalSessions: amCharts_v4_pie_chart;
    public activeSessionBaselineSession: amCharts_v4_area_line_chart;

    public publishCountByContentGroupTooltip : infoButton_template;
    protected publishCountByContentGroupContent;

    public publishCountByDayToolTip : infoButton_template;

    public sessionsByContentTypeGroupTooltip : infoButton_template;
    protected sessionsByContentTypeGroupContent;

    public activeSessionsBaselineSessionTooltip : infoButton_template;
    protected activeSessionsBaselineSessionContent;

    public isActiveFilter : multipleSelector_template

    protected getTemplateHtml(): string{

        return /*html*/`
            <div class="sub-header filter-preset w-justify ">
            ${this.filterPreset.getHtmlBuild()}
            </div>

            <div class="sub-header w-justify">
                
                <div class=" w-justify" style="z-index: 9999;">
                    <div class="w-left">
                        
                        ${this.dateFilter.getHtmlBuild()}
                        ${this.networkCategoriesFilter.getHtmlBuild()}
                        ${this.filterContentType.getHtmlBuild()}
                        ${this.filterUser.getHtmlBuild()}
                        ${this.intentFilter.getHtmlBuild() } 
                        ${this.isActiveFilter.getHtmlBuild() } 
                    </div>
                  
                </div>
                
            </div>
            
            
                    <div class="w-filters-selected">
                        <div id="filters-selected" class="filters-selected">
                           <div id="selected-contentType"></div>
                           <div id="selected-network_categories"></div>
                           <div id="selected-intents"></div>
                           <div id="selected-active"></div>
                           <div id="selected-tags" data-bind="visible: usersArray().length > 0">
                                <label class="small">Selected Users:</label>
                                <div class="form-group" data-bind="foreach: usersArray">
                                    <button class="btn-f-s icon i-x-after" type="button" data-bind=", text: name, event: { click: $parent.onClickDeleteUserArray }"></button>
                                </div>
                            </div>
                        </div>   
                    </div>
<!--                    dashboard body -->
                    <div class="w-dashboard" id="w-dashboard">
                        <div class="dashboard" id="dashboard">
                            <div class="w-card">
                                <div class="form-pagination">
                                    <button class="btn icon" type="button" data-bind="event: { click: onClickTabLeft.bind($data,'publishCount') }, css: { 'is-activated' : selectedTabLeft() == 'publishCount'}"><span class="btn-text">Publish Count by Content Type Group
                                        <div class="w-tooltips-adv short in-line pos-bottom" style="display: inline-block" data-bind="visible: selectedTabLeft() == 'publishCount'">
                                            ${this.publishCountByContentGroupTooltip.getHtmlBuild()}
                                        </div></span>
                                    </button>               
                                    <button class="btn icon" type="button" data-bind="event: { click: onClickTabLeft.bind($data,'sessionCount') }, css: { 'is-activated' : selectedTabLeft() == 'sessionCount'}">
                                    <span class="btn-text">Sessions by Content Type Group
                                        <div class="w-tooltips-adv short in-line pos-bottom" style="display: inline-block" data-bind=" visible: selectedTabLeft() == 'sessionCount'">
                                            ${this.sessionsByContentTypeGroupTooltip.getHtmlBuild()}
                                        </div>                                    
                                        </span>
                                    </button>

                                </div>
                                <div class="w-tabs-content" data-bind="css: { 'is-showing' : selectedTabLeft() == 'publishCount'}">
                                    <div class="w-chart-external-legend">
                                        
                                        ${this.publishCount.getHtmlBuild()}
                                        <div class="legend">
                                            <div class="legend-item affiliate">Affiliate</div>
                                            <div class="legend-item authority">Authority</div>
                                            <div class="legend-item feature">Feature</div>
                                            <div class="legend-item list">List</div>                                        
                                            <div class="legend-item news">News</div>
                                            <div class="legend-item resource">Resource</div>                                        
                                        </div>                                         
                                    </div>    
                                </div>    
                                <div class="w-tabs-content" data-bind="css: { 'is-showing' : selectedTabLeft() == 'sessionCount'}">
                                    <div class="w-pie">
                                        <div class="pie">
                                            <div class="pie-title"><span>Active</span> Sessions</div>
                                               
                                            ${this.activeSessions.getHtmlBuild()}
                                        </div> 
                                        <div class="pie">       
                                            <div class="pie-title"><span>Total</span> Sessions</div>                                                                         
                                            ${this.totalSessions.getHtmlBuild()}
                                        </div> 
                                        <div class="legend span-2">
                                            <div class="legend-item affiliate">Affiliate</div>
                                            <div class="legend-item authority">Authority</div>
                                            <div class="legend-item feature">Feature</div>
                                            <div class="legend-item list">List</div>
                                            <div class="legend-item news">News</div>
                                            <div class="legend-item resource">Resource</div>                                        
                                        </div> 
                                    </div>
                                   
                                </div>
                            </div>    
                             <div class="w-card">
                                 <div class="form-pagination">
                                     <button class="btn icon" type="button" data-bind="event: { click: onClickTabRight.bind($data,'activeSessionBaselineSession') }, css: { 'is-activated' : selectedTabRight() == 'activeSessionBaselineSession'}"><span class="btn-text">Active Sessions and Baseline Sessions by Day
                                        <div class="w-tooltips-adv short in-line pos-bottom" style="display:inline-block" data-bind="visible: selectedTabRight() == 'activeSessionBaselineSession'">
                                            ${this.activeSessionsBaselineSessionTooltip.getHtmlBuild()}
                                            </div>
                                        </span>
                                     </button>               
                                     <button class="btn icon" type="button" data-bind="event: { click: onClickTabRight.bind($data,'publishCount') }, css: { 'is-activated' : selectedTabRight() == 'publishCount'}"><span class="btn-text">Publish Count by Day
                                     
                                     <div class="w-tooltips-adv short in-line pos-bottom" style="display: inline-block" data-bind="visible: selectedTabRight() == 'publishCount'">
                                            ${this.publishCountByDayToolTip.getHtmlBuild()}
                                        </div>
                                     </span></button>

                                 </div>
                                 <div class="w-tabs-content" data-bind="css: { 'is-showing' : selectedTabRight() == 'activeSessionBaselineSession'}">
                                    <div class="w-card">
                                        <div class="w-chart-external-legend">
                                        
                                            ${this.activeSessionBaselineSession.getHtmlBuild()}
                                            <div class="legend">
                                                <div class="legend-item affiliate">Baseline</div>
                                                <div class="legend-item feature">Active</div>
                                            </div>                                                          
                                        </div>
                                    </div>
                                    
                                </div>
                                <div class="w-tabs-content" data-bind="css: { 'is-showing' : selectedTabRight() == 'publishCount'}">
                                    <div class="w-card">
                                        <div class="w-chart-external-legend">
                                            ${this.publishCountStacked.getHtmlBuild()} 
                                            <div class="legend">
                                                <div class="legend-item feature">New Article Publish Count</div>
                                                <div class="legend-item affiliate">Republish Count</div>
                                            </div>                                                                                
                                        </div>
                                    </div>
                                </div>
                             </div>
                            <div class="w-card span-2" id="author-list">
                                <div class="list-header w-justify" >
                                    <div class="w-left">
                                        <div class="dashboard-title">Authors</div>
                                    </div>
                                    <div class="w-right">
                                        <button data-bind="event: { click: $data.onClickCSVExport }" class="btn highlight" type="button">ExportCSV</button>
                                        ${this.pagination.getHtmlBuild()}
                                    </div>
                                </div>
                            
                                <div class="w-list-results" id="list-results">
                                    <table class="list-results">
                                        ${this.resultInfos.getHtmlBuild()}
                                        <thead>
                                            <tr>
                                                <th><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'authorName') }, css: { 'list-sort-desc': orderByAndDirection()=='authorName_DESC', 'list-sort-asc': orderByAndDirection()=='authorName_ASC' }">Author Name</span></th>
                                                <th><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'newArticlesPublished') }, css: { 'list-sort-desc': orderByAndDirection()=='newArticlesPublished_DESC', 'list-sort-asc': orderByAndDirection()=='newArticlesPublished_ASC' }">New Articles Published</span></th>
                                                <th><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'articleRepublishCount') }, css: { 'list-sort-desc': orderByAndDirection()=='articleRepublishCount_DESC', 'list-sort-asc': orderByAndDirection()=='articleRepublishCount_ASC' }">Article Republish Count</span></th>
                                                <th><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'sessions') }, css: { 'list-sort-desc': orderByAndDirection()=='sessions_DESC', 'list-sort-asc': orderByAndDirection()=='sessions_ASC' }">Sessions</span></th>
                                                <th><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'activeSessions') }, css: { 'list-sort-desc': orderByAndDirection()=='activeSessions_DESC', 'list-sort-asc': orderByAndDirection()=='activeSessions_ASC' }">Active Sessions</span></th>
                                                <th><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'activeSA') }, css: { 'list-sort-desc': orderByAndDirection()=='activeSA_DESC', 'list-sort-asc': orderByAndDirection()=='activeSA_ASC' }">Active S/A</span></th>
                                                <th><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'failureRate') }, css: { 'list-sort-desc': orderByAndDirection()=='failureRate_DESC', 'list-sort-asc': orderByAndDirection()=='failureRate_ASC' }">Failure Rate</span></th>
                                                <th><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'successRate') }, css: { 'list-sort-desc': orderByAndDirection()=='successRate_DESC', 'list-sort-asc': orderByAndDirection()=='successRate_ASC' }">Success Rate</span></th>
                                            </tr>
                                        </thead>
                                        <tbody data-bind="foreach: authors">
                                            
                                            <tr>
                                                <td><span data-bind="text: AuthorName"></span></td>
                                                <td><span data-bind="text: newArticlesPublished"></span></td>
                                                <td><span data-bind="text: articleRepublish"></span></td>
                                                <td><span data-bind="text: sessions"></span></td>
                                                <td><span data-bind="text: activeSessions"></span></td>
                                                <td><span data-bind="text: ActiveSA"></span></td>
                                                <td><span data-bind="text: failureRate"></span></td>                                                
                                                <td><span data-bind="text: successRate"></span></td>
                                            </tr>
                                            
                                        </tbody>
                                    </table>
                                </div>
                            </div>  
                        </div>                            
                    </div>
                
            
            `;
    }

    protected initPartial(): void{

        this.filter = new filterSimple_template("filter", this.getTemplateViewModel(), this.caller);
        this.pagination = new pagination_template("pagination", this.getTemplateViewModel(), this.caller);
        this.pagination.getTemplateViewModel().itemPerPage = 25;
        this.resultInfos = new resultsInfo_template("resultInfo", this.getTemplateViewModel(), this.caller)

        this.dateFilter = new filterDate_template("dateFilter", this.getTemplateViewModel(), this.caller);
        this.setDefaultDateRange();

        this.networkCategoriesFilter = new multipleSelector_template("networkCategoriesFilter", this.getTemplateViewModel(), this.caller);
        this.networkCategoriesFilter.setLabel("network categories");
        this.networkCategoriesFilter.setFilterContainerClass('margin-neg');
        this.networkCategoriesFilter.setTagContainerId('selected-network_categories');
        this.networkCategoriesFilter.setTagContainerCaption('Selected network categories:');

        this.intentFilter = new multipleSelector_template("intentFilter", this.getTemplateViewModel(), this.caller);
        this.intentFilter.setLabel("Intent");
        this.intentFilter.setFilterContainerClass('margin-neg');
        this.intentFilter.setTagContainerId('selected-intents');
        this.intentFilter.setTagContainerCaption('Selected Intents:');


        this.isActiveFilter = new multipleSelector_template("isActiveFilter", this.getTemplateViewModel(), this.caller);
        this.isActiveFilter.setLabel("Active");
        this.isActiveFilter.setFilterContainerClass('margin-neg');
        this.isActiveFilter.setTagContainerId('selected-active');
        this.isActiveFilter.setTagContainerCaption('Selected active:');

        this.filterContentType = new multipleSelector_template("filterContentType", this.getTemplateViewModel(), this.caller);
        this.filterContentType.setLabel("Content Type");
        //this.filterContentType.setFilterContainerClass('margin-neg');
        this.filterContentType.setTagContainerId('selected-contentType');
        this.filterContentType.setTagContainerCaption('Selected content type:');

        this.filterUser = new filterAutocomplete_template("filterUser", this.getTemplateViewModel(), this.caller);
        this.filterUser.setPlaceholder( 'Users' );

        this.filterPreset = new filterPreset_template("filterPreset", this.getTemplateViewModel(), this.caller);

        //False by default, then set to true later on
        // this.setCanSearchUsers(false);

        this.filterPreset.getTemplateViewModel().searchPresetType('authorManagement');

        this.publishCount = new amCharts_v4_column_chart("amCharts_v4_column_chart", this.getTemplateViewModel(), this.caller);
        this.publishCount.setXAxisRotation(-90);
        this.publishCount.setXAxisFontSize(14);

        this.activeSessions = new amCharts_v4_pie_chart("amCharts_v4_pie_chart_active_sessions", this.getTemplateViewModel(), this.caller);
        this.activeSessions.setXAxisRotation(-90);
        this.activeSessions.setXAxisFontSize(14);

        this.totalSessions = new amCharts_v4_pie_chart("amCharts_v4_pie_chart_total_sessions", this.getTemplateViewModel(), this.caller);
        this.totalSessions.setXAxisRotation(-90);
        this.totalSessions.setXAxisFontSize(14);

        this.activeSessionBaselineSession = new amCharts_v4_area_line_chart("amcharts_v4_area_line_chart", this.getTemplateViewModel(), this.caller);
        this.activeSessionBaselineSession.setXAxisRotation(-90);
        this.activeSessionBaselineSession.setXAxisFontSize(14);

        this.publishCountStacked = new amCharts_v4_column_chart("amCharts_v4_column_chart_stacked", this.getTemplateViewModel(), this.caller);
        this.publishCountStacked.setXAxisRotation(12);
        this.publishCountStacked.setXAxisFontSize(14);

        this.publishCountByContentGroupContent = `
        <p>This chart includes new articles only.</p><p>Article Republish instances are not included here.</p>
        `

        this.publishCountByContentGroupTooltip = new infoButton_template('publishCountByContentGroup', this.getTemplateViewModel(), this.caller)
        this.publishCountByContentGroupTooltip.setTitle('Publish Count By Content Type Group');
        this.publishCountByContentGroupTooltip.setContent(this.publishCountByContentGroupContent);

        this.publishCountByDayToolTip = new infoButton_template('publishCountByDayToolTip', this.getTemplateViewModel(), this.caller)
        this.publishCountByDayToolTip.setTitle('Publish Count By Content Type Group');
        this.publishCountByDayToolTip.setContent(this.publishCountByContentGroupContent);

        this.sessionsByContentTypeGroupContent = `<p><strong>Active Sessions</strong> are the sessions <strong>on the current day</strong> for all articles published <em>within the date range</em> than are less than 30D old.</p>`;

        this.sessionsByContentTypeGroupTooltip = new infoButton_template('sessionsByContentTypeGroup', this.getTemplateViewModel(), this.caller);
        this.sessionsByContentTypeGroupTooltip.setTitle('Sessions By Content Type Group');
        this.sessionsByContentTypeGroupTooltip.setContent(this.sessionsByContentTypeGroupContent);

        this.activeSessionsBaselineSessionContent = `<p><strong>Active Sessions</strong> are the sessions <strong>on the current day</strong> for all articles published <em>within the date range</em> than are less than 30D old.</p><p><strong>Baseline Sessions</strong> are all accumulated sessions for the date range minus active sessions.</p>`;
        this.activeSessionsBaselineSessionTooltip = new infoButton_template('activeSessionsBaselineSessionTooltip', this.getTemplateViewModel(), this.caller);
        this.activeSessionsBaselineSessionTooltip.setTitle('Active Sessions And Baseline Sessions By Day');
        this.activeSessionsBaselineSessionTooltip.setContent(this.activeSessionsBaselineSessionContent);


    }

    protected getTemplateName(): string{
        return "authorManagement-template";
    }

    protected getMainElementType(): string{
        return "div";
    }

    protected getMainElementClasses(): Array<string>{
        return ["w-content"];
    }

    protected buildViewModel(): any{

        let self = this;
        return{
            orderBy: ko.observable("sessions"),
            orderByDirection: ko.observable("DESC"),
            authors: ko.observableArray([]),
            publishCount: ko.observableArray([]),
            publishCountStacked: ko.observableArray([]),
            activeSessions: ko.observableArray([]),
            activeSessionBaselineSession: ko.observableArray([]),
            totalSessions: ko.observableArray([]),
            orderByAndDirection: ko.observable("sessions_DESC"),
            selectedTabLeft: ko.observable('publishCount','sessionCount'),
            selectedTabRight: ko.observable('activeSessionBaselineSession','publish count'),
            usersArray: ko.observable([]),
            isExport: ko.observable(false),
            contentTypeGroupIdsToExclude: ko.observable([7]),
            onClickReorder: function (value, data, event){
                self.onClickReorder(value, data, event);
            },
            onClickTabLeft: function (value, data, event) {
                self.onClickTabLeft(value);
            },
            onClickTabRight: function (value, data, event) {
                self.onClickTabRight(value);
            },
            onClickCSVExport: function (value, data, event) {
                self.onClickCSVExport();
            },
            onClickDeleteUserArray: function (data, event) {
                self.onClickDeleteUserArray(data);
            }
        };

    }

    public buildDatePickerCalendar(){

        this.dateFilter.buildCalendar();
    }

    public getViewModelForRequest(){

        return {
              pagination: this.getTemplateViewModel().pagination
            , searchPresetName: this.getTemplateViewModel().filterPreset.searchPresetName()
            , searchPresetType: 'authorManagement'
            , isExport: this.getTemplateViewModel().isExport
            , filters      : {
                orderBy : this.viewModel.list.orderBy,
                orderByDirection : this.viewModel.list.orderByDirection,
                orderByAndDirection: this.getTemplateViewModel().orderByAndDirection,
                dateFilterType: this.getTemplateViewModel().dateFilter.selectedFilter(),
                startDate: this.getTemplateViewModel().dateFilter.startDate(),
                endDate: this.getTemplateViewModel().dateFilter.endDate(),
                startDateRange: this.getTemplateViewModel().dateFilter.fromRange(),
                endDateRange: this.getTemplateViewModel().dateFilter.toRange(),
                networkCategories: this.getTemplateViewModel().networkCategoriesFilter.selectedItems,
                intent: this.getTemplateViewModel().intentFilter.selectedItems,
                isActive: this.getTemplateViewModel().isActiveFilter.selectedItems,
                contentTypeIds: this.getTemplateViewModel().filterContentType.selectedItems,
                idAuthor: this.getTemplateViewModel().usersArray().map(obj => obj.id),
                authorNames: this.getTemplateViewModel().usersArray()
            },
        }
    }

    public onClickReorder(value, data, event){

        data.orderBy(value);
        //if column has already been sorted, flip the direction
        if (data.orderByAndDirection().includes(value)) {
            if (data.orderByDirection() == "DESC") {
                data.orderByDirection("ASC");
            } else {
                data.orderByDirection("DESC");
            }
        } else {
            //default column sort direction
            data.orderByDirection("DESC");
        }

        data.orderByAndDirection(value + "_" + data.orderByDirection());

        this.caller.articlesListReorder();
    }

    public setAuthors(authors): void {

        this.getTemplateViewModel().authors(authors);
    }

    public setResultInfo(nbResults, nbPages, execTime ){

        this.resultInfos.setExecutionTime(execTime);
        this.resultInfos.setNbResults(nbResults);
        this.resultInfos.setNbPages(nbPages);
    }

    public setNetworkCategoriesFilterItems(items){

        items.unshift({'id': 0, 'name' : 'no network categories'});
        this.networkCategoriesFilter.setItems(items);
    }

    public setIntentFilterItems(items){

        this.intentFilter.setItems(items);
    }

    public setIsActiveFilterItems(items){
        this.isActiveFilter.setItems(items);
    }

    public setContentType(filterList: Array<{ id: number, name: string }>): void {

        this.filterContentType.setItems(filterList);
    }

    public getContentType() {

        return this.filterContentType.getItems();
    }

    public getContentTypeGroups(){
        return this.filterContentType.getGroups();
    }

    public setGroupContentTypeFilterItems(groupContentTypes){
        let groups = [];
        let contentTypeGroupIdsToExclude = this.getContentTypeGroupIdsToExclude();
        for ( let groupContentType of groupContentTypes){
            if (contentTypeGroupIdsToExclude.indexOf(groupContentType.id) == -1) {

                let group = {"name" : groupContentType.name, "items" : groupContentType.contentTypes};
                groups.push(group);
            }
        }

        this.filterContentType.setMultiSectionItems(groups);
        this.filterContentType.setLabel('Content Type');
    }

    protected onClickTabLeft(tab){
        this.getTemplateViewModel().selectedTabLeft(null);
        this.getTemplateViewModel().selectedTabLeft(tab);
    }

    protected onClickTabRight(tab){
        this.getTemplateViewModel().selectedTabRight(null);
        this.getTemplateViewModel().selectedTabRight(tab);
    }

    public onClickCSVExport(){
        this.getTemplateViewModel().isExport(null);
        this.getTemplateViewModel().isExport(true)
        this.caller.exportList();

    }
    public exportData(responseParsed){
        this.getTemplateViewModel().isExport(false);
        downloadCSV({filename: "authorManagement.csv", data: responseParsed});
    }

    public setViewModelFromRequest(urlParams){

        //check if URL has filters or user preferences
        if (urlParams != null){

            // date filters.
            if(urlParams.dateFilterType){
                this.dateFilter.getTemplateViewModel().selectedFilter(urlParams.dateFilterType);
            }
            if(urlParams.startDateRange || urlParams.endDateRange){

                this.dateFilter.setRange(urlParams.startDateRange, urlParams.endDateRange);
            }

            if(urlParams.startDate || urlParams.endDate) {
                this.setDateFilters(urlParams.startDate, urlParams.endDate);
            }

            this.setFilterSelectedItems(this.filterContentType, urlParams.contentTypeIds);
            this.setFilterSelectedItems(this.networkCategoriesFilter, urlParams.networkCategories);
            this.setFilterSelectedItems(this.intentFilter, urlParams.intent);
            this.setFilterSelectedItems(this.isActiveFilter, urlParams.isActive);
            this.setUserFilterSelectedItems(this.filterUser,urlParams);

            if(urlParams.orderBy){
                this.getTemplateViewModel().orderBy(urlParams.orderBy);
                let orderByParts = this.getTemplateViewModel().orderByAndDirection().split('_');
                orderByParts[0] = urlParams.orderBy;
                this.getTemplateViewModel().orderByAndDirection(orderByParts.join('_'));
            }

            if(urlParams.orderByDirection){
                this.getTemplateViewModel().orderByDirection(urlParams.orderByDirection);
                let orderByParts = this.getTemplateViewModel().orderByAndDirection().split('_');
                orderByParts[1] = urlParams.orderByDirection;
                this.getTemplateViewModel().orderByAndDirection(orderByParts.join('_'));
            }
        }
    }

    public setSearchPresets(presets){
        this.filterPreset.setSearchPresets(presets);
    }

    public addCreatedPresetToList(response){
        this.filterPreset.addCreatedPresetToList(response);
    }

    public setUserFilterSelectedItems(objFilter,urlParams){
        let objUser = [];

        // Multi select filters.
        if('authorNames' in urlParams){
            //idAuthor
            // for(const obj of urlParams.)
            this.getTemplateViewModel().usersArray(urlParams.authorNames);
        }
    }

    public setFilterSelectedItems(objFilter, urlParams){

        let splitString = [];

        // Multi select filters.
        if(urlParams){
            if(typeof urlParams == "string"){
                splitString = urlParams.split(",");
            }else{
                splitString = [urlParams];
            }
            let arrayParam = [];
            let idTagArray = [];
            splitString.forEach((id) => {
                if(!isNaN(Number(id))){
                    id = Number(id);
                }else{
                    id = id.replaceAll("+", " ");
                }
                arrayParam.push({ id: id });
                idTagArray.push(id);
            });
            objFilter.setSelectedItems(arrayParam);
            objFilter.setTags(idTagArray, objFilter.getItems());
        }else{
            objFilter.setSelectedItems([]);
            objFilter.setTags([], objFilter.getItems());
        }
    }

    private setDateFilters(startDate, endDate) {
        if(startDate){
            startDate = new Date(startDate.replace(/-/g, '\/'));
        }
        if(endDate){
            endDate = new Date(endDate.replace(/-/g, '\/'));
        }

        this.dateFilter.setDateRange(startDate, endDate);
    }

    public setDefaultDateRange(){

        // date filters.
        this.dateFilter.getTemplateViewModel().selectedFilter("range");
        this.dateFilter.setRange("-30d", "-1d");
    }

    public setPublishCount(publishCount): void {

        this.getTemplateViewModel().publishCount(publishCount);

        publishCount.category = "category";
        publishCount.yAxis = "count";
        publishCount.xAxis = "category";
        publishCount.name = "Count";
        publishCount.horizontalCenter = "middle";
        publishCount.minimalValue = 0;

        publishCount.isStacked = false;

        this.publishCount.drawChart(publishCount);
    }

    public setPublishCountStacked(publishCountStacked): void{
        this.getTemplateViewModel().publishCountStacked(publishCountStacked);

        publishCountStacked.category = "category";
        publishCountStacked.yAxis = "count";
        publishCountStacked.xAxis = "category";
        publishCountStacked.name = "Count";
        publishCountStacked.isStacked = true;
        publishCountStacked.rotate = 90;
        publishCountStacked.horizontalCenter = "right";
        publishCountStacked.verticalCenter = "middle";
        publishCountStacked.series1Fill = "#1870B9";
        publishCountStacked.series2Fill = "#2BBCAB";

        this.publishCountStacked.drawChart(publishCountStacked);

    }

    public setActiveSessions(activeSessions): void{
        activeSessions.legend = false;
        this.activeSessions.drawChart(activeSessions);
    }

    public setTotalSessions(totalSessions): void{
        totalSessions.legend = false;
        this.totalSessions.drawChart(totalSessions);
    }

    public setActiveSessionBaselineSession(activeSessionBaselineSession): void{
        let newObj = {
            data: activeSessionBaselineSession,
            series1ValueY:"baseline",
            series1DateX : "date",
            series1Name : "Baseline",
            series1Fill : "#2BBCAB",
            series2ValueY : "activeSA",
            series2DateX : "date",
            series2Name : "Active SA",
            series2Fill : "#1870B9"
        };

        this.activeSessionBaselineSession.drawChart(newObj);

    }

    public onClickDeleteUserArray(data) {
        let selectedUserArray = this.getTemplateViewModel().usersArray();
        let index = selectedUserArray.findIndex(i => i.id == data.id);
        if (index != -1) {
            selectedUserArray.splice(index, 1);
        }

        this.getTemplateViewModel().usersArray(selectedUserArray);
        this.caller.filterSimpleOnChange();
    }

    public getContentTypeGroupIdsToExclude(): Array<number> {

        return this.getTemplateViewModel().contentTypeGroupIdsToExclude();
    }
}


// WEBPACK FOOTER //
// ./js/components/templates/author_management_template.ts